import { DeleteVideos } from '@/connection/content/videos';
import { RootState } from '@/store/main';
import { ContentReducerCreator, ContentState } from '../types';
import { cannotDeleteToast } from '../utils';

const deleteRecordingReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number, { getState }) => {
      const state = (getState() as RootState).content as ContentState;
      return await DeleteVideos(channel, Object.keys(state.contentMarkedForDeletion));
    },
    {
      fulfilled: (state, action) => {
        if (action.payload.cannotDelete.length) {
          const cannotDeleteSet = new Set(action.payload.cannotDelete || []);

          const errorMessage =
            state.recordings
              ?.filter((video) => cannotDeleteSet.has(video.uuid))
              .map((video) => video.name)
              .join(', ') || '';
          cannotDeleteToast(errorMessage);
        }

        if (state.recordings) {
          state.recordings = state.recordings.filter((vid) => !action.payload.videoIDs.includes(vid.uuid));
          state.contentMarkedForDeletion = {};
        }
      },
    }
  );
};

export default deleteRecordingReducer;
